import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { closePopup, openPopup } from "../../../general/Modal/action";
import { MODALS } from "../../../general/Modal/constants";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { getRouting, formDataGenerator, digitToRupeeNotation } from "../../../../../utils/common";
import "./style.scss";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import {
  getEtf,
  getEtfListOfFunds,
  getEtfFundList,
  postEtfSubscribe,
  clearSubscribeResult,
  subscribeProduct,
  postSmallCase,
  postInvestDataETF, postSmallCaseID,
  getSchemeContentNode
} from "../actions";
import Slider from "react-slick";
import { Helmet } from "react-helmet";


const ETF = (props) => {
  const {
    getEtf,
    getEtfData,
    getEtfListOfFunds,
    getEtfFunds,
    getEtfFundList,
    getEtfFundListData,
    postEtfSubscribe,
    etfSubscribeSuccess,
    getSchemeContentNode,
    getNodeSchemeData
  } = props;
  const [banner, setBanner] = useState();
  const [listOfFunds, setListOfFunds] = useState();
  const [whatAreETFs, setWhatAreETFs] = useState();
  const [whyHDFCMFETFs, setWhyHDFCMFETFs] = useState();
  const [reacentArticles, setReacentArticles] = useState();
  const [benifits, setBenifits] = useState();
  //   const [benefitsUrl, setBenefitsUrl] = useState();
  //   const [informationBenifits, setInformationBenifits] = useState();
  const [allFunds, setallFunds] = useState([]);
  const [allFundsStatus, setallFundsStatus] = useState(false);
  const [etfSubscribeSuccessStatus, setEtfSubscribeSuccessStatus] = useState(0);
  const [creationUnit, setcreationUnit] = useState(false);
  const [fundCount, setfundCount] = useState(5);

  useEffect(() => {
    getEtf();
  }, []);

  useEffect(() => {
    if (getNodeSchemeData) {
      const { postSmallCase, getNodeSchemeData, openPopup, closePopup, postInvestDataETF, postSmallCaseID, location } = props;
      let modalData = {
        closeAction: closePopup,
        modalClass: 'basic-form-etf',
        postSmallCase,
        getNodeSchemeData,
        postSmallCaseID,
        location,
      }
      openPopup(MODALS.BASIC_FORM_ETF, modalData)
    }
  }, [getNodeSchemeData]);

  useEffect(() => {
    let params = {
      limit: fundCount,
    };
    getEtfFundList(formDataGenerator(params));
  }, [fundCount]);

  useEffect(() => {
    if (getEtfData && getEtfData.etfList && getEtfData.etfList.banner) {
      setBanner(getEtfData.etfList.banner);
    }

    if (getEtfData && getEtfData.etfList && getEtfData.etfList.description) {
      setWhyHDFCMFETFs(getEtfData.etfList.description);
    }
    if (getEtfData && getEtfData.etfList && getEtfData.etfList) {
      setWhatAreETFs(getEtfData.etfList);
    }
    if (getEtfData && getEtfData.etfList && getEtfData.etfList.article) {
      setReacentArticles(getEtfData.etfList.article);
    }
    if (getEtfData && getEtfData.etfList && getEtfData.etfList.benifits) {
      setBenifits(getEtfData.etfList.benifits);
      //   setBenefitsUrl(
      //     getEtfData &&
      //       getEtfData.etfList &&
      //       getEtfData.etfList.benifits &&
      //       getEtfData.etfList.benifits
      //   );
      //   setInformationBenifits(
      //     getEtfData &&
      //       getEtfData.etfList &&
      //       getEtfData.etfList.benifits &&
      //       getEtfData.etfList.benifits
      //   );
    }
  }, [getEtfData]);

  useEffect(() => {
    if (etfSubscribeSuccessStatus === 0) {
      if (
        etfSubscribeSuccess &&
        etfSubscribeSuccess.etfSubscribeSuccess &&
        etfSubscribeSuccess.etfSubscribeSuccess.status
      ) {
        setEtfSubscribeSuccessStatus(1);
        formik.resetForm();

        setTimeout(() => {
          setEtfSubscribeSuccessStatus(0);
        }, 30000);
      }
    }
  }, [etfSubscribeSuccess]);

  useEffect(() => {
    if (
      getEtfFundListData &&
      getEtfFundListData.etfFundList &&
      getEtfFundListData.etfFundList.data
    ) {
      setListOfFunds(getEtfFundListData.etfFundList.data);
    }

    if (allFundsStatus === false) {
      let params = {
        is_fund_facts: ''
      };
      if (
        getEtfFundListData &&
        getEtfFundListData.etfFundList &&
        getEtfFundListData.etfFundList.data
      ) {
        getEtfFundListData &&
          getEtfFundListData.etfFundList &&
          getEtfFundListData.etfFundList.data.length > 0 &&
          getEtfFundListData.etfFundList.data.map((itemNav) => {
            getEtfListOfFunds(formDataGenerator(params), itemNav.suggestedUrl);
          });
        setallFundsStatus(true);
      }
    }
  }, [getEtfFundListData]);

  useEffect(() => {
    let params = {
      is_fund_facts: ''
    };
    const apiInterval = setInterval(() => {
      getEtfFundListData &&
        getEtfFundListData.etfFundList &&
        getEtfFundListData.etfFundList.data.length > 0 &&
        getEtfFundListData.etfFundList.data.map((itemNav) => {
          getEtfListOfFunds(formDataGenerator(params), itemNav.suggestedUrl);
        });
    }, 5000);
    return () => {
      // clean up
      clearInterval(apiInterval);
    };
  }, [getEtfFundListData]);

  useEffect(() => {
    if (
      getEtfFunds &&
      getEtfFunds.etfFunds &&
      getEtfFunds.etfFunds.navs &&
      getEtfFunds &&
      getEtfFunds.etfFunds &&
      getEtfFunds.etfFunds.navs[0]
    ) {
      const arrayMapUpdate = [];

      getEtfFundListData &&
        getEtfFundListData.etfFundList &&
        getEtfFundListData.etfFundList.data &&
        getEtfFundListData.etfFundList.data.length > 0 &&
        getEtfFundListData.etfFundList.data.map((item) => {
          if (item.nodeID == getEtfFunds.etfFunds.navs[0].fundId) {
            item.inav = getEtfFunds.etfFunds.navs[0].navValue;
            item.navDate = getEtfFunds.etfFunds.navs[0].navDate;
            const preNav = item.previousNav;
            const navValue = item.inav - item.previousNav;
            const prevValue = Number(preNav) + Number(item.inav);
            const prevValueDiv = prevValue / 2;
            const totalValue = (navValue / prevValueDiv) * 100;
            const checktotal = Number(totalValue).toFixed(2);
            if(checktotal === '0.00' || checktotal === '-0.00')
            {
              item.Changes = "0.00"
            }
            else{
              item.Changes = checktotal
            }
            arrayMapUpdate.push(item);
          } else {
            arrayMapUpdate.push(item);
          }
        });
      setListOfFunds(arrayMapUpdate);
    }
  }, [getEtfFunds]);

  //   const handleApiCall = async (event) => {
  //     setBenefitsUrl(event && event.benefitsUrl);
  //     setInformationBenifits(event && event.information);
  //   };

  const [email, setEmail] = useState();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("email is not correct")
      .required("Please Enter your address details"),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: (data) => {
      let payload = {
        email: data.email,
      };
      postEtfSubscribe(formDataGenerator(payload));
    },
  });

  useEffect(() => {
    if (formik.values.email) {
      setEmail(formik.values.email);
    }
  }, [formik.values.email]);

  const handleRadioBtn = (e) => {
    setcreationUnit(e.target.checked);
  };

  const handleFundCountAll = (e) => {
    setfundCount(e);
  };

  const scrollToTop = () => {
    if (creationUnit == false) {
      window.scrollTo({
        top: 1400,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 1900,
        behavior: "smooth",
      });
    }
  };

  const onSmallCase = async (fundItem) => {
    getSchemeContentNode(fundItem.suggestedUrl);
    // const { postSmallCase, item } = this.props;

    // await postSmallCase(item.ticker)
    // eslint-disable-next-line no-undef
    // scGate.triggerTransaction({ transactionId: this.props.txnId }) .then(res => res) .catch(err => err)
  }

  // const settings = {
  //   dots: true,
  //   autoplay: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1
  // }

  return (
    <div>
      {getEtfData && getEtfData.etfList && getEtfData.etfList.meta && <Helmet>
        <title>{getEtfData.etfList.meta.title}</title>
        <meta name="description" content={getEtfData.etfList.meta.description} />
        <meta name="keywords" content={getEtfData.etfList.meta.keywords} />
        <meta property="og:title" content={getEtfData.etfList.meta.og_title} />
        <meta property="og:description" content={getEtfData.etfList.meta.description} />
        <meta property="og:image" content={getEtfData.etfList.meta.og_image} />
        <meta property="og:url" content={getEtfData.etfList.meta.og_url} />
      </Helmet>}
      <section>
        {/* <Slider {...settings} className="slick-car"> */}
          {banner &&
            banner.length > 0 &&
            banner.map((ban, index) => (
              <div className="firstcar mt-3">
                <img className="d-block w-100"
                  src={ban.bannerUrl}
                  // src="/images/New/product-solution/etfbackground.svg" 
                  alt="First slide" />
                <div className="carousel-caption">
                  <div className="row">
                    <div className="carousel-text col-lg-5">
                      <h1>{ban.title}</h1>
                      <div className="d-flex mt-5">
                        <div className="btn btn-white mb-4 mb-md-0" onClick={() => scrollToTop()} >
                          {ban && ban.url && ban.url[0] && ban.url[0].title}
                        </div>

                        <a href={ban && ban.url && ban.url[1] && ban.url[1].url} target="blank">
                          <div className="btn btn-outline-white ms-3 mb-4 mb-md-0 d-flex align-items-center">
                            {ban && ban.url && ban.url[1] && ban.url[1].title}
                            <img className="ms-2" src="/images/New/product-solution/etfarrow.svg" alt="etf-investment-arrow-icon" />
                          </div>
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            ))}
        {/* </Slider> */}
      </section>
      <section>
        <div className="bgblue py-5">
          <div className="container table-responsive">
            <h2 className="etfheding mb-4 text-center">List Of Funds</h2>
            <table className="table etftable mb-5">
              <tr>
                <th>Scheme</th>
                <th>Real time iNAV (₹)</th>
                <th>Previous NAV (₹)</th>
                <th>Changes %</th>
                <th></th>
              </tr>
              <tbody>
                {listOfFunds &&
                  listOfFunds.length > 0 &&
                  listOfFunds.map((fund, index) => (
                    <tr>
                      <td className="text-center">
                        <Link
                          to={getRouting(`/product-solutions/overview${fund.suggestedUrl}/regular`)}
                        >
                          {fund.title}
                        </Link>
                        <p className="etfSymbols">NSE / BSE symbol: {fund.nseSymbol?fund.nseSymbol:'NA'}</p>
                        <p className="etfSymbols">BSE Scrip Code: {fund.bseScripCode?fund.bseScripCode:'NA'}</p>
                      </td>
                      <td>
                        <p className={
                          Number(fund.inav) > Number(fund.previousNav)
                            ? "text-center text-success"
                            : "text-center text-danger"}>
                          {fund && fund.inav ? "₹" : ""} {fund && fund.inav}{" "}</p>
                        <p className="text-center">{fund && fund.navDate}</p>
                      </td>
                      <td className="text-center">
                        {" "}
                        {fund.previousNav ? "₹" : ""} {fund.previousNav}
                      </td>
                      <td className="text-center">
                        {fund && fund.Changes} {fund && fund.Changes ? "%" : ""}{" "}
                      </td>
                      <td className="text-center" >
                        <div className="btn btn-primary" onClick={(e) => onSmallCase(fund)}>
                          <a
                            className="investnow"
                            href="javascript:void(0)"

                          >
                            Invest Now
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="container">
            {(getEtfFundListData &&
              getEtfFundListData.etfFundList &&
              getEtfFundListData.etfFundList.count) !=
              (getEtfFundListData &&
                getEtfFundListData.etfFundList &&
                getEtfFundListData.etfFundList.data &&
                getEtfFundListData.etfFundList.data.length) ? (
              <div className="d-flex justify-content-center">
                <div
                  className="btn loadmore"
                  onClick={(e) =>
                    handleFundCountAll(
                      getEtfFundListData &&
                      getEtfFundListData.etfFundList &&
                      getEtfFundListData.etfFundList.count
                    )
                  }
                >
                  Load More
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="d-flex align-items-center justify-content-center my-4">
              <div className="d-flex align-items-center ">
                <label className="checkboxc">
                  <input type="checkbox" checked={creationUnit} value={creationUnit} onClick={handleRadioBtn} />
                  <span className="checkmark" ></span>
                </label>
                <p className="ms-3 checkpara">View Creation Unit Size and Tentative Basket Value</p>
              </div>
            </div>
            {creationUnit == true ? (
              <div className="table-responsive">
                <table className="table etftabledetail mb-5">
                  <tr>
                    <th>Scheme Name</th>
                    <th>Tentative Basket Value (in Lakhs)</th>
                    <th>Unit Size</th>
                  </tr>
                  <tbody>
                    {listOfFunds &&
                      listOfFunds.length > 0 &&
                      listOfFunds.map((fund, index) => {

                        const bigValue = Number(fund.inav) > Number(fund.previousNav) ? fund.inav : fund.previousNav;
                        const percentValue = Number(bigValue) * 0.02;
                        const totalValue = fund.unitSize ? (Number(bigValue) + Number(percentValue)) * (fund.unitSize) : '';
                        const finalValue = totalValue != '' ? Math.round(totalValue) : '';
                        let finalValueLength;
                        if(finalValue && finalValue.toString().length > 7){
                          finalValueLength = finalValue.toString().slice(0, 3);
                        }else if(finalValue){
                          finalValueLength = finalValue.toString().slice(0, 2);
                        }
                        return (
                          <tr>
                            <td className="text-center">
                              {fund.title ? fund.title : ""}
                            </td>
                            <td className="text-center">
                              {finalValueLength}
                            </td>
                            <td className="text-center">
                              {fund.unitSize ? digitToRupeeNotation(fund.unitSize) : ""}
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
            <p className="disclaimertxt">
              Disclaimer: Exchange Traded Funds (ETFs) are mutual funds that
              trade on stock exchanges like stocks and can be bought and sold
              during market hours.{" "}
            </p>
          </div>
        </div>
        <div className="container py-4">
          <div className="mt-5">
            <div className="row gx-5 whatetf align-items-center">
              <div className="col-md-6 order-2 order-md-1">
                <h2 className="mb-3 etfhead">
                  {whatAreETFs && whatAreETFs.title}
                </h2>
                {whatAreETFs && whatAreETFs.body ? (
                  <div dangerouslySetInnerHTML={{ __html: whatAreETFs.body }} />
                ) : null}
              </div>
              <div className="col-md-6 order-1 order-md-2">
                <img
                  src={whatAreETFs && whatAreETFs.thumbnail && whatAreETFs.thumbnail.url}
                  alt={whatAreETFs && whatAreETFs.thumbnail && whatAreETFs.thumbnail.alt}
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bgblue bg-height pt-3 pt-md-5 pb-5">
          <h2 class="text-center mb-5 benefitetf">Benefits of ETFs</h2>
          <div className="container benefitcarousel">
            <Tabs>
              <TabList>
                <Tab>
                  <div>
                    <p>{benifits && benifits[0].name}</p>
                    <div className="circle"></div>
                  </div>
                </Tab>

                <Tab>
                  <div>
                    <p>{benifits && benifits[1].name}</p>
                    <div className="circle"></div>
                  </div>
                </Tab>

                <Tab>
                  <div>
                    <p>{benifits && benifits[2].name}</p>
                    <div className="circle"></div>
                  </div>
                </Tab>

                <Tab>
                  <div>
                    <p>{benifits && benifits[3].name}</p>
                    <div className="circle"></div>
                  </div>
                </Tab>
                <Tab>
                  <div>
                    <p>{benifits && benifits[4].name}</p>
                    <div className="circle"></div>
                  </div>
                </Tab>
              </TabList>
              <hr className="craouselline" />
              <TabPanel>
                <div>
                  <div className="row d-md-flex">
                    <div className="col-md-6">
                      <img className="img-fluid" src={benifits && benifits[0] && benifits[0].benefitsUrl} alt={benifits && benifits[0] && benifits[0].alt} />
                    </div>
                    <div className="col-md-6 d-flex align-items-center mt-4 mt-md-0">
                      {benifits && benifits[0] ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: benifits[0].information,
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  <div className="row d-md-flex">
                    <div className="col-md-6">
                      <img className="img-fluid" src={benifits && benifits[1] && benifits[1].benefitsUrl} alt={benifits && benifits[1] && benifits[1].alt} />
                    </div>
                    <div className="col-md-6 d-flex align-items-center mt-4 mt-md-0">
                      {benifits && benifits[1] ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: benifits[1].information,
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  <div className="row d-md-flex">
                    <div className="col-md-6">
                      <img className="img-fluid" src={benifits && benifits[2] && benifits[2].benefitsUrl} alt={benifits && benifits[2] && benifits[2].alt} />
                    </div>
                    <div className="col-md-6 d-flex align-items-center mt-4 mt-md-0">
                      {benifits && benifits[2] ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: benifits[2].information,
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  <div className="row d-md-flex">
                    <div className="col-md-6">
                      <img className="img-fluid" src={benifits && benifits[3] && benifits[3].benefitsUrl} alt={benifits && benifits[3] && benifits[3].alt} />
                    </div>
                    <div className="col-md-6 d-flex align-items-center mt-4 mt-md-0">
                      {benifits && benifits[3] ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: benifits[3].information,
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  <div className="row d-md-flex">
                    <div className="col-md-6">
                      <img className="img-fluid" src={benifits && benifits[4] && benifits[4].benefitsUrl} alt={benifits && benifits[4] && benifits[4].alt} />
                    </div>
                    <div className="col-md-6 d-flex align-items-center mt-4 mt-md-0">
                      {benifits && benifits[4] ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: benifits[4].information,
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
        <div className="container py-4">
          <div className="mt-5">
            <div className="etfsection p-5">
              {whyHDFCMFETFs ? (
                <div dangerouslySetInnerHTML={{ __html: whyHDFCMFETFs }} />
              ) : null}
            </div>
            <div className="mt-5 articles">
              {reacentArticles &&
                reacentArticles.length > 0 ?
                <h2 className="mb-4">Recent Articles</h2> : ""}
              <div className="row gx-5">
                {reacentArticles &&
                  reacentArticles.length > 0 &&
                  reacentArticles.map((article, index) => (
                    <div className="col-md-4">
                      <div className="card border-0">
                        <Link to={getRouting(article.suggestedUrl)}>
                          <img className="card-img-top" src={article.thumbnail && article.thumbnail.url} alt={article.thumbnail && article.thumbnail.alt} />
                        </Link>
                        <div className="card-body px-0">
                          <Link to={getRouting(article.suggestedUrl)}>
                            <h5 className="card-title">{article.title}</h5>
                          </Link>
                          <p className="card-text">{article.summary}</p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div>
              {etfSubscribeSuccessStatus === 0 ? (
                <div className="row">
                  <div className="col-md-12">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="bg-warning mt-5 mb-5">
                        <div className="row px-3 py-5">
                          <div className="col-md-9 mx-auto">
                            <div>
                              <h3 className='text-center mb-3'>Did you find this interesting</h3>
                              <p className="text-center mb-3">
                                Subscribe & stay updated
                              </p>
                              <div className="row">
                                <div className="col-md-8 mb-3">
                                  <input
                                    type="text"
                                    placeholder="Email Addess"
                                    name="email"
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                    className={
                                      "invalid form-control" +
                                      (formik.errors.email &&
                                        formik.touched.email
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <div className="invalid-feedback">
                                    {formik.errors.email && formik.touched.email
                                      ? formik.errors.email
                                      : null}
                                  </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <button
                                    className="w-100 btn btn-primary"
                                    type="submit"
                                  >
                                    Subscribe
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              ) : (
                <div className="bg-warning row px-3 py-5 thanks">
                  <div className="col-md-6 mx-auto">
                    <div>
                      <h3 className="text-center mb-3">
                        Subscribe to our exclusive newsletter to get our latest
                        updates
                      </h3>
                      <button className="w-100 btn btn-primary" type="button">
                        Thanks For Signing Up
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  getEtfData: state.ProductSolution.home,
  getEtfFunds: state.ProductSolution.home,
  etfSubscribeSuccess: state.ProductSolution.home,
  getEtfFundListData: state.ProductSolution.home,
  getNodeSchemeData: state.ProductSolution.home.schemeDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getEtf: bindActionCreators(getEtf, dispatch),
  getEtfListOfFunds: bindActionCreators(getEtfListOfFunds, dispatch),
  getEtfFundList: bindActionCreators(getEtfFundList, dispatch),
  postEtfSubscribe: bindActionCreators(postEtfSubscribe, dispatch),
  // small case API
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
  subscribeProduct: bindActionCreators(subscribeProduct, dispatch),
  clearSubscribeResult: bindActionCreators(clearSubscribeResult, dispatch),
  postSmallCase: bindActionCreators(postSmallCase, dispatch),
  postInvestDataETF: bindActionCreators(postInvestDataETF, dispatch),
  postSmallCaseID: bindActionCreators(postSmallCaseID, dispatch),
  getSchemeContentNode: bindActionCreators(getSchemeContentNode, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ETF);